<p>
  {{ errorMessage | l10n}}
</p>
